import React from "react";
import "../../css/components/controls/HrnbSkeleton.css";

export default function HrnbSkeleton({ width, height, circle = false, className = "", style = {} }) {
    return (
        <div
            className={`hrnb-skeleton ${circle ? "hrnb-skeleton--circle" : ""} ${className}`}
            style={{
                width: width || "100%",
                height: height || "16px",
                ...style,
            }}
        />
    );
}

export function SkeletonText({ lines = 1, width, className = "" }) {
    return (
        <div className={`skeleton-text ${className}`}>
            {Array.from({ length: lines }).map((_, i) => (
                <HrnbSkeleton
                    key={i}
                    height="14px"
                    width={typeof width === "string" ? width : width?.[i] || "100%"}
                    style={{ marginBottom: i < lines - 1 ? "8px" : 0 }}
                />
            ))}
        </div>
    );
}

export function SkeletonCard({ header = true, lines = 3, footer = true }) {
    return (
        <div className="skeleton-card">
            {header && (
                <div className="skeleton-card__header">
                    <HrnbSkeleton width="40%" height="18px" />
                    <HrnbSkeleton width="60px" height="22px" circle />
                </div>
            )}
            <SkeletonText lines={lines} width={["90%", "85%", "60%"]} />
            {footer && (
                <div className="skeleton-card__footer">
                    <HrnbSkeleton width="80px" height="32px" />
                    <HrnbSkeleton width="80px" height="32px" />
                </div>
            )}
        </div>
    );
}

export function SkeletonList({ count = 5 }) {
    return (
        <div className="skeleton-list">
            {Array.from({ length: count }).map((_, i) => (
                <div key={i} className="skeleton-list__item">
                    <HrnbSkeleton width="48px" height="48px" circle />
                    <div className="skeleton-list__body">
                        <HrnbSkeleton width="60%" height="16px" />
                        <HrnbSkeleton width="40%" height="12px" />
                    </div>
                </div>
            ))}
        </div>
    );
}
